import { useState } from 'react';

export const useForm = (initialValues) => {
    const [formData, setFormData] = useState(initialValues);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const resetForm = () => setFormData(initialValues);

    const setFieldValue = (name, value) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return { formData, handleChange, resetForm, setFieldValue, setFormData };
};
